<template>
  <v-card>
    <v-card-title>
      <h3 class="headline mb-0">Все смены</h3>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="priyomsmena"
        :search="search"
        :loading="loading"
        loading-text="Загрузка. Пожалуйста подождите"
          :footer-props="{
              'items-per-page-options': [ 7, 20, 50, 100],
              'items-per-page-text':'Строк на странице',
          }"
          no-data-text="Данные отсутствуют в таблице"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Смены</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Поиск"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template>

        <template v-slot:item.status_smena="{ item }">
            <v-icon v-if="item.status_smena==1" color="primary" >{{ getIcon(item.status_smena) }}</v-icon>
            <v-icon v-if="item.status_smena==2" color="error">{{ getIcon(item.status_smena) }}</v-icon>
            <v-icon v-if="item.status_smena==3" color="success" >{{ getIcon(item.status_smena) }}</v-icon>
        </template>

        <template v-slot:no-data>
          <v-btn color="primary" text >
            Обновить
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>


    <v-snackbar
    v-model="snack"
    :timeout="3000"
    :color="snackColor"
  >
    {{ snackText }}

    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        text
        @click="snack = false"
      >
        Закрыть
      </v-btn>
    </template>
  </v-snackbar>

  </v-card>
</template>

<script>
export default {

    data: () => ({
        headers: [
        {
            text: '№',
            align: 'start',
            value: 'id_smena_org',
        },
        { text: 'Кассир', value: 'fio' },
        { text: 'Дата открытии', value: 'sana_ogoz' },
        { text: 'Дата закрытии', value: 'sana_anjom' },
        { text: 'Сумма наличий', value: 'savdo_nakd' },
        { text: 'Статус', value: 'status_smena' },
        { text: 'Действия', value: 'actions', sortable: false },

        ],
        priyomsmena: [],
        smena: {},
        loading: false,

        snack: false,
        snackColor: '',
        snackText: '',

        search: '',



    }),

    mounted(){
        this.get_PriyomSmena();
    },

    methods: {
        get_PriyomSmena(){

            this.loading = true;
            axios.get('/api/get_PriyomSmena',
                    {
                        headers: {
                            "Content-type": "application/json"
                        }
                    })
                    .then(response => {
                            if(response.data.status){
                                this.loading = false;
                                this.priyomsmena = response.data.priyomsmena;
                            }else{
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = "Ошибка получения истории смен!"
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                            }
                        })
                        .catch(error => {
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = error.response.data.message;
                                setTimeout(() => {
                                    this.snack = false;
                                }, 2000);
                        });

        },

        getIcon (status_smena) {
        if (status_smena == 1) return 'mdi-lock-open-variant'
        else if (status_smena == 2) return 'mdi-lock'
        else if (status_smena == 3) return 'mdi-check-bold'
        else return 'mdi-file-question'
      },
    }

}
</script>

<style>

</style>




